import { get } from 'lodash';

const commonErrorState = {
	isValid: false,
	isFocusOn: true,
	showValidation: true,
	isBackEndError: true,
};

const getFieldErrorState = ({ state, errorCode, addPayeeKey, fieldName }) => ({
	...state,
	[addPayeeKey]: {
		...state[addPayeeKey],
		[fieldName]: {
			...state[addPayeeKey][fieldName],
			...commonErrorState,
			errorCode,
		},
	},
});

export const backEndErrorStates = (error, state, addPayeeKey) => {
	const errorCode = get(error[0], 'error_code', '');
	switch (errorCode) {
		case '027':
			return {
				...state,
				[addPayeeKey]: {
					...state[addPayeeKey],
					sortCode: {
						...state[addPayeeKey].sortCode,
						...commonErrorState,
						errorCode,
					},
					accountNumber: {
						...state[addPayeeKey].accountNumber,
						...commonErrorState,
						isFocusOn: false,
						errorCode,
					},
				},
			};
		case '17':
			return getFieldErrorState({ state, errorCode, addPayeeKey, fieldName: 'iban' });
		case '22':
			return getFieldErrorState({ state, errorCode, addPayeeKey, fieldName: 'iban' });
		case '21':
			return getFieldErrorState({ state, errorCode, addPayeeKey, fieldName: 'bickOrSwift' });
		case '302':
			return getFieldErrorState({ state, errorCode, addPayeeKey, fieldName: 'payeeAccountType' });
		default:
			return { ...state, hasError: true };
	}
};
